
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/domain-contact",
      function () {
        return require("private-next-pages/domain-contact/index.tsx");
      }
    ]);
  